<template>
  <div :class='[postion ? "positionA":""]' :style='{right:right+"px",bottom:bottom+"px"}'>
    <el-link style="width: 10px;height: 10px;"  @click="copy" :underline="false" icon="el-icon-document-copy"></el-link>
  </div>
</template>

<script>
export default {
  props:{
    text:{
        type:String,
        default:"",
      },
    postion:{
       type:Boolean,
       default:false
    },  
    left:{
      type:Number,
      default:0,      
    },
    right:{
      right:Number,
      default:0,      
    },
    top:{
      type:Number,
      default:15,      
    },
    bottom:{
      type:Number,
      default:0,      
    }
  },
  methods:{
    copy(){
      let data = this.text
      let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        console.log(oInput.value)
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
    }
  }
}
</script>

<style lang="scss" scoped>
     .positionA{
        position:absolute;
     }
</style>